"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_TEAM = void 0;
var GET_TEAM = exports.GET_TEAM = 'GET_TEAM';